module.exports = __webpack_public_path__ + "static/media/acct_global-functionality.18153e8f.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/acct_global-functionality.md
// module id = 1077
// module chunks = 0